import { ButtonContainer } from "@/components";
import {
  HistoricoContainer,
  Table,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "./style";
import { useHistorico } from "./useHistorico";

export function Historico() {
  const { conversation, extractLastWord } = useHistorico();

  return (
    <HistoricoContainer>
      <Table>
        <TableHeader>
          <TableHeaderCell>Data</TableHeaderCell>
          <TableHeaderCell>Status</TableHeaderCell>
          <TableHeaderCell>Mensagem</TableHeaderCell>
        </TableHeader>
        {conversation.map((row, i) => (
          <TableRow key={i} $index={i}>
            <TableCell>
              {new Date(row.date).toLocaleDateString("pt-BR")}
            </TableCell>
            <TableCell>{extractLastWord(row.subject)}</TableCell>
            <TableCell>{row.firstWords}</TableCell>
          </TableRow>
        ))}
      </Table>

      <ButtonContainer />
    </HistoricoContainer>
  );
}
